import AWS from "aws-sdk";
import config from "../config.js";

const getAllDetails = async () => {
  AWS.config.update(config.aws_remote_config);
  const docClient = new AWS.DynamoDB.DocumentClient();
  var params = {
    TableName: config.aws_table_name,
  };

  return await docClient.scan(params).promise()
};

export default getAllDetails();
